module.exports = __webpack_public_path__ + "img/IClaim-active.9cac2475.svg";